// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mn-2";
export var interactiveWrapper = "_mn-0";
export var shippingHoverPreview = "_mn-4";
export var summaryBadgeTrigger = "_mn-1";
export var widgetHoverPreviewList = "_mn-3";
export var widgetPreviewScale = "_mn-5";